module.exports = __webpack_public_path__ + "media/fonts/fa-brands-400-189fd81995406d669dfa189d6b5328dc.woff";